import { API_URLS } from '../constants/apiUrls';
import type { CaptchaResponse } from '../types/api.types';

/**
 * GET /api/captcha
 * Fetches a fresh server-generated CAPTCHA image and its associated ID.
 * Call on page mount and whenever a new CAPTCHA is needed after a failure.
 */
export async function fetchCaptcha(jwtToken: string): Promise<CaptchaResponse> {
  const response = await fetch(API_URLS.captcha, {
    method:  'GET',
    headers: { 'Authorization': `Bearer ${jwtToken}` },
  });

  if (!response.ok) {
    throw new Error('CAPTCHA_UNAVAILABLE');
  }

  return response.json() as Promise<CaptchaResponse>;
}
